import React, { useState, Fragment } from "react";
import SideNav from "./SideNav/SideNav";
import FlyoutTrigger from "../../common/Modals/Flyout/FlyoutTrigger";
import Flyout from "../../common/Modals/Flyout/Flyout";
import Button from "../../common/Buttons/Button/Button";
import FlyoutActions from "../../common/Modals/Flyout/FlyoutActions/FlyoutActions";
import useSignOut from "../../../lib/auth/hooks/useSignout";

interface Props {
    children?: GenericModalChildren;
}

const SideNavFlyout = ({ children }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const signOut = useSignOut();

    const toggleFlyout = () => {
        setIsOpen((state) => !state);
    };

    return (
        <Fragment>
            <FlyoutTrigger onClick={toggleFlyout}>{children}</FlyoutTrigger>

            <Flyout isOpen={isOpen} onClose={toggleFlyout}>
                <Flyout.Header onClose={toggleFlyout}>Menu</Flyout.Header>
                <Flyout.Content>
                    <SideNav />
                </Flyout.Content>
                <FlyoutActions className="justify-center">
                    <Button type="button" variant="borderedMint" icon="log_out" onClick={signOut}>
                        sign out
                    </Button>
                </FlyoutActions>
            </Flyout>
        </Fragment>
    );
};

export default SideNavFlyout;
